import { render, staticRenderFns } from "./AskCourse.vue?vue&type=template&id=7c159645&"
import script from "./AskCourse.vue?vue&type=script&lang=js&"
export * from "./AskCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports